import { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner";

const AddCreditsModal = ({
    show,
    handleClose,
    fetchBilling,
    hasPaymentMethod,
    last4,
    formattedExpDate,
    brand,
    openCardModal,
    paymentSettings
}) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });
    const [creditAmount, setCreditAmount] = useState("");
    const [autoRecharge, setAutoRecharge] = useState(false);
    const [minBalance, setMinBalance] = useState("5");
    const [rechargeTarget, setRechargeTarget] = useState("10");
    const [loadingRechardItems, setLoadingRechardItems] = useState(true)

    useEffect(() => {
        if (show) {
            setAutoRecharge(paymentSettings.auto_recharge)

            setLoadingRechardItems(true)
            if (paymentSettings.autoRecharge) {
                setMinBalance(paymentSettings.min_balance)
                setRechargeTarget(paymentSettings.recharge_target)
            }
            setTimeout(() => {
                setLoadingRechardItems(false)
            }, 800);

        }
    }, [show, user_id]);


    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setCreditAmount("");
        setAutoRecharge(false);
    };

    const handleAutoRecharge = (value) => {
        setAutoRecharge(value);
    };

    const StartPayment = async () => {
        if (!creditAmount || parseFloat(creditAmount) < 10) {
            setError({ message: "Minimum credit amount has to be $10", display: true });
            return;
        }

        if (autoRecharge) {
            if (!minBalance || parseFloat(minBalance) < 5) {
                setError({ message: "Minimum balance has to be $5", display: true });
                return;
            }
            if (!rechargeTarget || parseFloat(rechargeTarget) < 10) {
                setError({ message: "Minimum rechard target has to be $10", display: true });
                return;
            }
        }

        setLoading(true);
        setError({ message: "", display: false });

        try {
            const body = {
                user_id,
                credit_amount: parseFloat(creditAmount).toFixed(2),
                auto_recharge: autoRecharge,
                min_balance: autoRecharge ? parseFloat(minBalance).toFixed(2) : null,
                recharge_target: autoRecharge ? parseFloat(rechargeTarget).toFixed(2) : null,
            };

            const response = await fetch("https://backend.erioon.com/add_credits", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });

            const data = await response.json();
            console.log(data)

            if (data.error) {
                setError({ message: data.error, display: true });
            }

            if (!response.ok) {
                throw new Error(data.error || "Failed to add credits");
            }

            fetchBilling();
            CloseModal();
        } catch (err) {
            console.log(err)
            setError({ message: err.message, display: true });
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">
                    Add credits{" "}
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip className="stripe_tooltip">
                                <p className="tooltip_title">How do payments work?</p>
                                <p className="tooltip_desc">We use Stripe for secure and seamless payments.</p>
                            </Tooltip>
                        }
                    >
                        <i className="fa-solid fa-info"></i>
                    </OverlayTrigger>
                </p>
                <p className="share_label_desc">
                    Credits allow you to use resources across the Erioon infrastructure.
                </p>

                {!hasPaymentMethod ? (
                    <div className="no_card" onClick={() => openCardModal(true)}>
                        <p>No card available</p>
                        <button className="add_card_btn">Add new card</button>
                    </div>
                ) : (
                    <>

                        {loadingRechardItems ? (
                            <div className="loading_rules_cont fade-in">
                                <div className="loading_rules_cont_title"></div>
                                {!autoRecharge ? (
                                    <>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                    </>
                                ) : (
                                    <>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                        <div className="loading_rules_cont_title"></div>
                                    </>
                                )}

                            </div>
                        ) : (
                            <>
                                <p className="modal_pre_body_pricing_title">Credits amount</p>
                                <div className="card_input_cont">
                                    <input
                                        className="card_input"
                                        type="number"
                                        value={creditAmount}
                                        onChange={(e) => setCreditAmount(e.target.value)}
                                        placeholder="$10"
                                        min="1"
                                    />
                                </div>
                                <p className="modal_pre_body_pricing_title">Card</p>
                                <div className="card_input_cont">
                                    <div className="card_input_div">
                                        <div>
                                            <span>
                                                {brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : ""}
                                            </span>
                                            <span>{formattedExpDate}</span>
                                        </div>
                                        <span>**** **** **** {last4}</span>
                                    </div>
                                </div>

                                <p className="modal_pre_body_pricing_title">Automatic recharge</p>
                                <div className="ai_allow_cont_opt">
                                    <button
                                        className={`ai_allow_choice ${!autoRecharge ? "selected" : ""}`}
                                        onClick={() => handleAutoRecharge(false)}
                                    >
                                        Off
                                    </button>
                                    <button
                                        className={`ai_allow_choice ${autoRecharge ? "selected" : ""}`}
                                        onClick={() => handleAutoRecharge(true)}
                                    >
                                        On
                                    </button>
                                </div>

                                {/* Show inputs only if auto recharge is ON */}
                                {autoRecharge && (
                                    <div className="auto_recharge_settings fade-in">
                                        <p className="modal_pre_body_pricing_title">Minimum balance</p>
                                        <p className="columns_section_subtitle">
                                            Add credits when balance goes below ${minBalance || 5}
                                        </p>
                                        <div className="card_input_cont">
                                            <input
                                                className="card_input"
                                                type="number"
                                                value={minBalance}
                                                onChange={(e) => setMinBalance(e.target.value)}
                                                placeholder="$5"
                                                min="1"
                                            />
                                        </div>
                                        <p className="columns_section_subtitle">Minimum: $5</p>

                                        <p className="modal_pre_body_pricing_title">Recharge target</p>
                                        <p className="columns_section_subtitle">
                                            Bring credit balance back up to ${rechargeTarget || 15}
                                        </p>
                                        <div className="card_input_cont">
                                            <input
                                                className="card_input"
                                                type="number"
                                                value={rechargeTarget}
                                                onChange={(e) => setRechargeTarget(e.target.value)}
                                                placeholder="$15"
                                                min="1"
                                            />
                                        </div>
                                        <p className="columns_section_subtitle">Minimum: $10</p>
                                    </div>

                                )}
                            </>
                        )}
                    </>
                )}

            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    {hasPaymentMethod && (

                        <button className="save_btn" onClick={StartPayment}>
                            {loading ? <Spinner loading={loading} /> : <span>Add credits</span>}
                        </button>
                    )}
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default AddCreditsModal;
